var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const IDBIsClosingError = { err: null };
export class Store {
    constructor(dbName = 'keyval-store', storeName = 'keyval') {
        this.dbName = dbName;
        this.storeName = storeName;
        this.dbp = this._open();
    }
    _open() {
        return new Promise((resolve, reject) => {
            const openreq = indexedDB.open(this.dbName, 1);
            openreq.onerror = () => reject(openreq.error);
            openreq.onsuccess = () => resolve(openreq.result);
            // First time setup: create an empty object store
            openreq.onupgradeneeded = () => {
                openreq.result.createObjectStore(this.storeName);
            };
        });
    }
    _withIDBStore(type, callback) {
        if (!this.dbp) {
            this.dbp = this._open();
        }
        return this.dbp.then(db => new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            let transaction;
            try {
                transaction = db.transaction(this.storeName, type);
            }
            catch (e) {
                // So there seems to be a bug in some IndexedDB implementations where the connection to the
                // database can close without us explicitly closing it. That will cause a sync error being
                // thrown when calling db.transaction(). So we catch it, and bubble this error to `local-db`
                // which will return null to the caller. And on the next use of the database we try to reopen
                // the connection.
                this.dbp = null;
                IDBIsClosingError.err = e;
                reject(IDBIsClosingError);
                return;
            }
            transaction.oncomplete = () => resolve();
            transaction.onabort = transaction.onerror = () => reject(transaction.error);
            callback(transaction.objectStore(this.storeName));
        })));
    }
}
export function get(key, storeToUse) {
    let req;
    return storeToUse
        ._withIDBStore('readonly', s => {
        req = s.get(key);
    })
        .then(() => (req.result === undefined ? null : req.result));
}
export function set(key, value, storeToUse) {
    return storeToUse._withIDBStore('readwrite', s => {
        s.put(value, key);
    });
}
export function del(key, storeToUse) {
    return storeToUse._withIDBStore('readwrite', s => {
        s.delete(key);
    });
}
export function clear(storeToUse) {
    return storeToUse._withIDBStore('readwrite', s => {
        s.clear();
    });
}
export function keys(storeToUse) {
    const validKeys = [];
    return storeToUse
        ._withIDBStore('readonly', s => {
        // This would be store.getAllKeys(), but it isn't supported by Edge or Safari.
        // And openKeyCursor isn't supported by Safari.
        (s.openKeyCursor || s.openCursor).call(s).onsuccess = function () {
            if (!this.result) {
                return;
            }
            validKeys.push(this.result.key);
            this.result.continue();
        };
    })
        .then(() => validKeys);
}
